import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService{

  constructor(private http: HttpClient) {}

  private handleError(error: HttpErrorResponse) {
    const errorMsg = error.error instanceof ErrorEvent ? 
      `Client-side error: ${error.error.message}` : 
      `Server-side error: ${error.status} - ${error.message}`;
      
    console.error(errorMsg);
    return throwError('An error occurred, please try again later.');
  }

  get<T>(url: string): Observable<T> {
    return this.http.get<T>(url).pipe(catchError(this.handleError));
  }

  post<P, R>(url: string, payload: P, headers?: HttpHeaders): Observable<R> {
    return this.http.post<R>(url, payload, { headers })
      .pipe(
        catchError(this.handleError)
      );
  }

  put<P, R>(url: string, payload: P): Observable<R> {
    return this.http.put<R>(url, payload)
      .pipe(
        catchError(this.handleError)
      );
  }
  delete<R>(url: string): Observable<R> {
    return this.http.delete<R>(url).pipe(catchError(this.handleError));
  }

  getPdf(url: string): Observable<HttpResponse<Blob>> {
    return this.http.get(url, { responseType: 'blob' as 'blob', observe: 'response' }).pipe(
      catchError(this.handleError)
    );
  }

  postPdf<P>(url: string, payload: P): Observable<HttpResponse<Blob>> {
    return this.http.post(url, payload, { responseType: 'blob' as 'blob', observe: 'response' }).pipe(
      catchError(this.handleError)
    );
  }
  putPdf<P>(url: string, payload: P): Observable<HttpResponse<Blob>> {
    return this.http.put(url, payload, { responseType: 'blob' as 'blob',  observe: 'response' }).pipe(
      catchError(this.handleError)
    );
  }
}
